import {IJournalDecadalDataRow} from './journal.controller';
import {IDataValue} from '../../api/api.types';
import {IFormController, ILogService} from 'angular';
import {ITranslateService} from 'angular-translate';
import {IDecadalJournalData} from '../../api/api.types';
import {ISnackbarService} from '../../snackbar/snackbar.service';
import {IDataValueApi} from '../../api/data-value-api.service';

interface IMeteoPair {
  precipitation: number;
  temperature: number;
}

const editDialogTemplate = require<string>('./edit-meteo-row-dialog.html');

export class DecadalMeteoTableController {

  static readonly $inject = ['$mdDialog','$translate', '$log', 'snackbarService', 'dataValueApi'];

  /**
   * ID of the station related to the data.
   */
  stationId: number;
  /**
   * Displayed decadal data.
   */
  decadalData: IJournalDecadalDataRow[];
  /**
   * Monthly average data.
   */
  monthlyValues: IMeteoPair|null;

  selectedRows: IJournalDecadalDataRow[];

  loadingInProgress: boolean;

  selectedYear: string;
  selectedMonth: string;

  loadJournal: () => void;

  constructor(
    private $mdDialog: ng.material.IDialogService,
    private $translate: ITranslateService,
    private $log: ILogService,
    private snackbarService: ISnackbarService,
    private dataValueApi: IDataValueApi) {
    this.selectedRows = [];
  }

  $onChanges() {
    this.decadalData = this.decadalData || [];
    if (this.decadalData.length == 0) {
      this.monthlyValues = null;
      return;
    }
    const accumulatedData: IMeteoPair = this.decadalData
        .reduce((previousValue, currentValue) => { 
          return {
            precipitation: previousValue.precipitation + currentValue.precipitation,
            temperature: previousValue.temperature + currentValue.temperature
          };
        }, {
          precipitation: 0,
          temperature: 0
        });
    this.monthlyValues = {
      precipitation: accumulatedData.precipitation,
      temperature: accumulatedData.temperature / this.decadalData.length
    };
  }

  get selectedRow(): IJournalDecadalDataRow|null {
    return this.selectedRows.length > 0 ? this.selectedRows[0] : null;
  }

  editRow($event: MouseEvent) {
    const dialogOptions: ng.material.IDialogOptions = {
      controller: EditDecadalMeteoDataRowDialogController,
      controllerAs: '$ctrl',
      escapeToClose: false,
      locals: {
        dataRow: this.selectedRow,
        stationId: this.stationId,
        year: this.selectedYear,
        month: this.selectedMonth + 1
      },
      targetEvent: $event,
      template: editDialogTemplate
    };
    this.$mdDialog.show(dialogOptions)
        .then((decadalData:IJournalDecadalDataRow) => {
          if (decadalData && decadalData.temperature) {
            this.selectedRow.temperature = decadalData.temperature;
          }
          if (decadalData && decadalData.precipitation) {
            this.selectedRow.precipitation = decadalData.precipitation;
          }
          this.snackbarService.show({
            content: this.$translate.instant(
                'METEO_DATA_WAS_EDITED')
          });
          this.loadJournal();
        })
        .catch(error => {
          if (error) {
            this.snackbarService.show({
              content: this.$translate.instant(
                  'ERROR_UPDATING_DATA')
            });
            this.$log.error(error);
          }
        });
  }

}

class EditDecadalMeteoDataRowDialogController {
  static readonly $inject = ['dataRow', 'stationId', 'month', 'year',
    '$mdDialog', 'dataValueApi'];

  /**
   * Edit form controller.
   */
  editForm: IFormController
  decade: number;
  temperature: number;
  precipitation: number;
  loadingInProgress: boolean;

  constructor(private dataRow: IJournalDecadalDataRow,
              private stationId: number,
              private month: number,
              private year: number,
              private $mdDialog: ng.material.IDialogService,
              private dataValueApi: IDataValueApi) {
    this.decade = dataRow.decadeInMonth;
    this.temperature = dataRow.temperature;
    this.precipitation = dataRow.precipitation;
    this.loadingInProgress = false;
  }

  /**
   * Apply the changes to the daily water level.
   */
  applyChanges() {

    this.dataValueApi.editMeteoDecadalData(
      this.stationId,
      this.year,
      this.month,
      this.decade,
      this.temperature,
      this.precipitation
    )
      .then(decadalData => {
        this.$mdDialog.hide({
          decadeInMonth: this.decade,
          temperature: this.temperature,
          precipitation: this.precipitation
        });
      })
      .catch(error => {
        this.$mdDialog.cancel(error);
      });
  }

  /**
   * Cancel the dialog without any changes.
   */
  cancel() {
    this.$mdDialog.cancel();
  }
}



/** WEBPACK FOOTER **
 ** ./app/operational/journal/decadal-meteo-table.controller.ts
 **/